import axios from "axios";
import { baseURL, slug } from "../helper/helper";

export const SET_LOADING = 'SET_LOADING';
export const SET_SITE_DATA = 'SET_SITE_DATA';
export const SET_SELECTED_INSTITUTION = 'SET_SELECTED_INSTITUTION';
export const SET_OUR_WORK = 'SET_OUR_WORK';
export const GET_INSTITUTION_DETAILS = 'GET_INSTITUTION_DETAILS';

// # Get all site content for a Madarsa
// curl -X GET "http://localhost:8000/api/v1/madarsas/site/faiz-ul-hasnain/"

export const getSiteData = () => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING, payload: true })
        try {
            const response = await axios.get(baseURL + `/madarsas/site/${slug}/`)
            console.log("Site Data:", response?.data)
            dispatch({ type: SET_SITE_DATA, payload: response.data })
        } catch (error) {
            console.log(error)
        } finally {
            dispatch({ type: SET_LOADING, payload: false })
        }
    }
}

export const applyAdmission = (data) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(baseURL + "/admissions/public/apply/", {
                madarsa_slug: slug,
                ...data
            })
            console.log("Admission Applied:", response?.data)
            return response.data
        } catch (error) {
            console.error("Admission Error:", error?.response?.data || error.message)
            throw error
        }
    }
}

export const submitContact = (data) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(baseURL + "/content/contact/", {
                madarsa_slug: slug,
                ...data
            })
            console.log("Contact Submitted:", response?.data)
            return response.data
        } catch (error) {
            console.error("Contact Error:", error?.response?.data || error.message)
            throw error
        }
    }
}

export const getInstitutionDetails = (instSlug) => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING, payload: true })
        try {
            // Fetching data from the public content info endpoint
            const response = await axios.get(baseURL + `/content/info/public/${instSlug}/`)
            console.log("Institution Details:", response?.data)
            dispatch({ type: SET_SELECTED_INSTITUTION, payload: response.data })
        } catch (error) {
            console.log(error)
        } finally {
            dispatch({ type: SET_LOADING, payload: false })
        }
    }
}

export const getOurWork = (tag = '') => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING, payload: true })
        try {
            const url = `/content/our-work/public/?madarsa_slug=${slug}${tag ? `&tag=${tag}` : ''}`
            const response = await axios.get(baseURL + url)
            console.log("Our Work Data:", response?.data)
            dispatch({ type: SET_OUR_WORK, payload: response.data })
        } catch (error) {
            console.log(error)
        } finally {
            dispatch({ type: SET_LOADING, payload: false })
        }
    }
}